import { render, staticRenderFns } from "./LoginRecoveryHelpCard.vue?vue&type=template&id=1bff0e66"
import script from "./LoginRecoveryHelpCard.vue?vue&type=script&lang=ts"
export * from "./LoginRecoveryHelpCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports